module.exports = __webpack_public_path__ + "img/support.fd11242c.svg";